export async function getConfigStorePaths(
  configStoreKey: string
): Promise<string[]> {
  const { client } = await useOpenFeature()
  const baseURL = (useRuntimeConfig().app.baseURL || '').replace(/\/$/, '')
  const value = client.getStringValue(configStoreKey, 'control')
  const path = `${baseURL}/api/v2/configs/${configStoreKey}`
  return [`${path}/${value}.json`, `${path}/control.json`]
}
